import * as swcHelpers from '@swc/helpers';

var sanitizeAddress = (_param)=>{
    var rest = swcHelpers.objectWithoutProperties(_param, [
        "addressTypes"
    ]);
    return Object.entries(rest).reduce((a, [k, v])=>v ? (a[k] = v, a) : a
    , {});
};

export { sanitizeAddress };
//# sourceMappingURL=sanitize-address.js.map
